var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgZoom({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "#4A8CFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 34.7637V58.3823C18.0208 63.7232 22.3497 68.0217 27.629 67.9999H61.7934C62.7646 67.9999 63.546 67.2125 63.546 66.2548V42.6363C63.5251 37.2954 59.1962 32.9969 53.9178 33.0187H19.7534C18.7822 33.0187 18.0008 33.8061 18.0008 34.7637H18ZM65.7204 43.9772L79.8256 33.5939C81.0505 32.5725 82 32.8275 82 34.679V66.3404C82 68.4469 80.8383 68.192 79.8256 67.4255L65.7204 57.0632V43.9772Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoom);
export default __webpack_public_path__ + "static/media/Zoom.741f85cf5ac21be1e7000ed9a2cc6012.svg";
export { ForwardRef as ReactComponent };